import React, { useEffect, useState } from 'react';

import { StyledRotatingText } from './RotatingText.styles';

import { RotatingTextProps } from './RotatingText.types';

import { getElementKeyDatasetForInfiniteAnimation } from '../../../';

const RotatingText = ({
  componentClassname = 'rotating-text',
  customClassnames = '',
  customStyle = '',
  textList = [],
  baseTextIndex = 0,
  intervalDelay = 2000,
  transitionDuration = 300,
  transitionEasing = 'ease-out',
}: RotatingTextProps) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(baseTextIndex);

  useEffect(() => {
    const goToNextText = () => {
      currentTextIndex + 1 >= textList.length
        ? setCurrentTextIndex(0)
        : setCurrentTextIndex((prevState) => prevState + 1);
    };
    const interval = setInterval(goToNextText, intervalDelay);
    return () => clearInterval(interval);
  }, [currentTextIndex, intervalDelay, textList.length]);

  return (
    <StyledRotatingText
      className={`${componentClassname} ${customClassnames}`}
      transitionDuration={transitionDuration}
      transitionEasing={transitionEasing}
      customStyle={customStyle}
    >
      {textList.map((text, index) => {
        return (
          <div
            key={text}
            className={`${componentClassname}__text ${
              index === currentTextIndex
                ? `${componentClassname}__text--is-active`
                : ''
            }`}
            style={
              {
                '--customKey': getElementKeyDatasetForInfiniteAnimation(
                  currentTextIndex,
                  index,
                  textList.length,
                ),
              } as React.CSSProperties
            }
          >
            {text}
          </div>
        );
      })}
    </StyledRotatingText>
  );
};
RotatingText.displayName = 'RotatingText';

export default RotatingText;
